import React, { useState } from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import Switch from '../../../core/form/Switch';
import TextInput from '../../../core/form/TextInput';
import Button from '../../../core/form/Button';

const AuthenticationOptionItem = (props) => {
  const [ssoOnly, setSsoOnly] = useState(props.ssoOnly);
  const [redirectUrl, setRedirectUrl] = useState(props.redirectUrl);

  return (
    <div>
      <label>
        <b>{startCase(props.app.toLowerCase())}</b>
      </label>
      <br />
      <Switch
        label="Only allow authentication by SSO"
        value={ssoOnly}
        onChange={(value) => {
          setSsoOnly(value);
          if (!value) {
            setRedirectUrl('');
          }
        }}
        disabled={props.disabled}
        titleOn="Yes"
        titleOff="No"
      />
      <TextInput
        label="SSO Redirect Url"
        disabled={props.disabled || !ssoOnly}
        value={redirectUrl}
        onChange={setRedirectUrl}
      />
      <Button
        label="Save"
        onClick={() => {
          props.onSave({ app: props.app, ssoOnly, redirectUrl });
        }}
      />
    </div>
  );
};

const WhitelabelConfigAuthenticationOptions = (props) => (
  <Row>
    {props.apps.map((app) => (
      <Column size={4} key={app.app}>
        <AuthenticationOptionItem disabled={props.disabled} onSave={props.onChange} {...app} />
      </Column>
    ))}
  </Row>
);

WhitelabelConfigAuthenticationOptions.propTypes = {
  disabled: PropTypes.bool,
  apps: PropTypes.arrayOf(
    PropTypes.shape({ app: PropTypes.string, ssoOnly: PropTypes.bool, redirectUrl: PropTypes.string })
  ),
  onChange: PropTypes.func.isRequired,
};

WhitelabelConfigAuthenticationOptions.defaultProps = {
  disabled: false,
  apps: [],
};

export default WhitelabelConfigAuthenticationOptions;
